<template>
  <div class="tab-btn label-content">
    <div class="content">
      <div class="top">
        <SimpleTable
          width="250px"
          :showIndex="false"
          table-code="QuotaListLeft"
          ref="QuotaListLeft"
          :loading="loading.left"
          :columns="columns.left"
          :data="tableData.left"
          @row-select="handleRowSelectLeft"
        />
        <SimpleTable
          width="250px"
          :showIndex="false"
          table-code="QuotaListCenter"
          ref="QuotaListCenter"
          :loading="loading.center"
          :columns="columns.center"
          :data="tableData.center"
          @row-select="handleRowSelectCenter"
        />
        <SimpleTable
          :showIndex="false"
          table-code="QuotaListRight"
          ref="QuotaListRight"
          :loading="loading.right"
          :columns="columns.right"
          :data="tableData.right"
          @row-select="handleRowSelectRight"
        />
      </div>
      <div class="bottom">
        <SimpleTable
          :showIndex="false"
          table-code="QuotaListBottom"
          ref="QuotaListBottom"
          :loading="loading.bottom"
          :columns="columns.bottom"
          :data="tableData.bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'QuotaList',
  inject: ['detailsVm'],
  components: {
    SimpleTable
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: {
        left: false,
        center: false,
        right: false,
        bottom: false
      },
      tableData: {
        left: [],
        center: [],
        right: [],
        bottom: []
      },
      columns: {
        left: [{ field: 'name', title: '定额名称' }],
        center: [{ field: 'name', title: '定额分类', tree: true }],
        right: [
          { field: 'code', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'unit', title: '单位' },
          { field: 'keywords', title: '关键词' }
        ],
        bottom: [
          { field: 'code', title: '编码', tree: true },
          { field: 'type', title: '类别' },
          { field: 'name', title: '人材机名称' },
          { field: 'spec', title: '规格型号' },
          { field: 'unit', title: '单位' },
          { field: 'content', title: '地区含量' },
          { field: 'enterpriseContent', title: '企业含量' },
          { field: 'keywords', title: '关键词' },
          { field: 'sysCreatedDate', title: '更新日期' }
        ]
      }
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      if (!this.basicInfo?.id) return
      this.getTableDataLeft()
    },
    async getTableDataLeft() {
      this.loading.left = true
      const res = await this.$service.get('/quota-library/list')
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.QuotaListLeft.initialized(0, 1)
    },
    async getTableDataCenter(obj) {
      this.loading.center = true
      const res = await this.$service.get(
        '/quota-library/quota-classify/tree',
        {
          quotaLibraryId: this.currentSelectLeft.id
        }
      )
      this.tableData.center = sortRecords(res.data || [])
      this.loading.center = false
      this.$refs.QuotaListCenter.initialized(0, 1)
    },
    async getTableDataRight(obj) {
      this.loading.right = true
      const res = await this.$service.get('/quota-library/quota-item/list', {
        quotaLibraryId: this.currentSelectLeft.id,
        quotaClassifyId: obj.id
      })
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
      this.$refs.QuotaListRight.initialized(0, 1)
    },
    async getTableDataBottom(obj) {
      this.loading.bottom = true
      const res = await this.$service.get(
        '/quota-library/quota-resource/tree',
        {
          quotaItemId: obj.id
        }
      )
      this.tableData.bottom = sortRecords(res.data || [])
      this.loading.bottom = false
      this.$refs.QuotaListBottom.initialized(0, 1)
    },

    handleRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.currentSelectLeft = obj
      this.getTableDataCenter(obj)
    },
    handleRowSelectCenter(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataRight(obj)
    },
    handleRowSelectRight(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataBottom(obj)
    }
  }
}
</script>

<style scoped lang="less">
.label-content {
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    > div {
      flex: 1;
      width: 100%;
    }
    .top {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
    }
  }
}
</style>
